import React from 'react'

 const Header = () => {
   return (
     <div className='sm:flex flex-col relative top-0 shadow-md w-full h-16 sm:h-8 text-white z-40 mb-0'
     >
         <h1 className="font-sans w-full fixed top-0 left-0 right-0 text-center items-center justify-center bg-gradient-to-r from-green-500 to-indigo-400">
          Hire Me! For the Web-Dev, Graphic Designs, Marketing. Connect Us Below 🚀
          </h1>
     </div>
   )
 }

 export default Header;

// import React from 'react';
// import { FaCode, FaPaintBrush, FaMobileAlt, FaChartLine, FaLinkedin, FaGithub, FaTwitter, FaEnvelope } from 'react-icons/fa';

// const Header = () => {
//   return (
//     <div className="w-full fixed top-0 left-0 right-0 z-50 shadow-lg">
//       <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white py-3 px-4">
//         <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between">
//           {/* Main Message */}
//           <div className="flex items-center mb-2 sm:mb-0">
//             <div className="flex-shrink-0 mr-3">
//               <span className="text-yellow-300 animate-pulse">🚀</span>
//             </div>
//             <h1 className="text-sm sm:text-base font-bold font-sans">
//               Hire Me For: 
//               <span className="ml-2 inline-flex flex-wrap gap-2 items-center">
//                 <span className="bg-white/20 px-2 py-1 rounded-md flex items-center">
//                   <FaCode className="mr-1" /> MERN Stack
//                 </span>
//                 <span className="bg-white/20 px-2 py-1 rounded-md flex items-center">
//                   <FaMobileAlt className="mr-1" /> Flutter Apps
//                 </span>
//                 <span className="bg-white/20 px-2 py-1 rounded-md flex items-center">
//                   <FaPaintBrush className="mr-1" /> Graphic Design
//                 </span>
//                 <span className="bg-white/20 px-2 py-1 rounded-md flex items-center">
//                   <FaChartLine className="mr-1" /> Digital Marketing
//                 </span>
//               </span>
//             </h1>
//           </div>

//           {/* Social Links */}
//           <div className="flex space-x-3">
//             <a 
//               href="https://linkedin.com/in/yourprofile" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="text-white hover:text-yellow-300 transition-colors"
//               aria-label="LinkedIn"
//             >
//               <FaLinkedin size={18} />
//             </a>
//             <a 
//               href="https://github.com/yourprofile" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="text-white hover:text-yellow-300 transition-colors"
//               aria-label="GitHub"
//             >
//               <FaGithub size={18} />
//             </a>
//             <a 
//               href="https://twitter.com/yourprofile" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="text-white hover:text-yellow-300 transition-colors"
//               aria-label="Twitter"
//             >
//               <FaTwitter size={18} />
//             </a>
//             <a 
//               href="mailto:youremail@example.com" 
//               className="text-white hover:text-yellow-300 transition-colors"
//               aria-label="Email"
//             >
//               <FaEnvelope size={18} />
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;

// import React from 'react';
// import { FaLaptopCode, FaPaintBrush, FaBullhorn, FaMobileAlt, FaRocket } from 'react-icons/fa';

// const Header = () => {
//   return (
//     <div className="w-full fixed top-0 z-50 shadow-lg bg-gradient-to-r from-purple-600 via-blue-500 to-green-400 text-white">
//       <div className="flex flex-col sm:flex-row items-center justify-center px-4 py-2 text-sm sm:text-base font-medium space-y-2 sm:space-y-0 sm:space-x-6 text-center">
//         <div className="flex items-center space-x-2">
//           <FaLaptopCode className="text-white" />
//           <span>MERN Stack</span>
//         </div>
//         <div className="flex items-center space-x-2">
//           <FaMobileAlt className="text-white" />
//           <span>Flutter Apps</span>
//         </div>
//         <div className="flex items-center space-x-2">
//           <FaPaintBrush className="text-white" />
//           <span>Graphic Design</span>
//         </div>
//         <div className="flex items-center space-x-2">
//           <FaBullhorn className="text-white" />
//           <span>Digital Marketing</span>
//         </div>
//         <div className="flex items-center space-x-2 font-semibold animate-pulse">
//           <FaRocket className="text-yellow-300" />
//           <span>Hire Me Now!</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;
